var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrefaLogoRgbPositive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.273,
    height: 75.273,
    viewBox: "0 0 75.273 75.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PREFA_Logo_RGB_Positive",
    transform: "translate(-5.253 -5.553)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 37.637,
    cy: 37.637,
    r: 37.637,
    transform: "translate(5.253 5.553)",
    fill: "#ff000f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M76.645,40.423c-.367-1.687-3.52-2.42-5.206-2.64a33.976,33.976,0,0,0-5.866-.147L54.354,18.5A38.141,38.141,0,0,0,38,22.385a33.191,33.191,0,0,0-8.653,6.526,7.924,7.924,0,0,1-4.986,2.053c-1.613.147-4.4.587-6.233,2.493a4.46,4.46,0,0,0-1.173,3.52,2.719,2.719,0,0,0-.073,2.713,7.627,7.627,0,0,0,3.593,1.833l-.293-3.593s-1.32-.66-1.54-1.54a2.593,2.593,0,0,1,1.467-2.273,11.519,11.519,0,0,1,3.74-.953l-3.3,18.552,2.64-.513,2.273.66,2.86-4.326,5.353,3.886.367,10.339,2.786-.513,2.64.66L43.5,53.329h2.713l3.226,3.226H57.58l1.393-1.32,7.993,6.746,2.64-.587,3.446.44L65.939,48.27l3.52-3.593s-.807-1.393-1.1-1.98c3.666-.293,4.84.44,5.206,1.027a2.236,2.236,0,0,1-.147,2.127s1.613-1.54,2.127-2.2C75.985,42.917,77.012,41.89,76.645,40.423Zm-28.3,2.346c-.587.367-2.42-.147-2.933-.22-.587-.073-3.74-.44-4.84,0-1.027.367-1.76.807-1.76,1.613a2.431,2.431,0,0,0,.367,1.32,26.782,26.782,0,0,1-2.42-2.713c-.293-.587-.807-1.613-.66-2.127.147-.587.367-1.54,2.64-2.347a19.753,19.753,0,0,1,5.94-.807c.587,0,3.52.073,3.813.367a6.542,6.542,0,0,1,.587,2.493C49,41.083,48.927,42.4,48.341,42.77Z",
    transform: "translate(-3.048 -3.484)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(22.928 62.091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M29.4,91.719h2.786V89.006h1.32c2.053,0,3.52-1.027,3.52-3.226a3.05,3.05,0,0,0-3.3-3.08H29.4Zm2.786-6.673h.88c.66,0,1.32.073,1.32.88,0,.88-.733.953-1.467.953h-.733Z",
    transform: "translate(-29.4 -82.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M40.3,91.719h2.786V88.566h1.467c1.1,0,1.173.88,1.247,1.76a9.169,9.169,0,0,0,.22,1.393h2.786a5.744,5.744,0,0,1-.293-1.907,2.521,2.521,0,0,0-1.32-2.273,2.268,2.268,0,0,0,1.32-2.273A2.646,2.646,0,0,0,45.58,82.7H40.3v9.019Zm2.786-6.893h1.32c1.027,0,1.393.293,1.393.88,0,.807-.733.88-1.247.88H43.086Z",
    transform: "translate(-32.307 -82.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M52.7,82.7h7.479v2.347H55.486v1.1h4.253v2.127H55.486v1.173h4.84v2.273H52.7Z",
    transform: "translate(-35.615 -82.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M64.1,82.7h7.259l-.073,2.347h-4.4v1.1h3.226v2.127H66.886v3.446H64.1Z",
    transform: "translate(-38.655 -82.7)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M71.3,91.719h2.786l.44-1.32h2.86l.367,1.32h2.86l-3.3-9.019H74.6Zm3.813-3.226.88-2.786h0l.807,2.786Z",
    transform: "translate(-40.576 -82.7)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrefaLogoRgbPositive);
export default __webpack_public_path__ + "static/media/PREFA_Logo_RGB_Positive.df0fcf7bff7bfba544db0859f22ede20.svg";
export { ForwardRef as ReactComponent };